import { Globe } from "lucide-react";
import { useCurrency } from "@/lib/currency";

export default function CurrencyPicker({ compact = false }) {
  const { currency, setCurrency, currencies } = useCurrency();
  if (!currencies.length) return null;

  return (
    <div data-testid="currency-picker" className={`relative flex items-center ${compact ? "w-full" : ""}`} title="Display & payment currency">
      <Globe className="w-3.5 h-3.5 text-zinc-500 absolute left-2.5 pointer-events-none" />
      <select
        data-testid="currency-picker-select"
        value={currency}
        onChange={(e) => setCurrency(e.target.value)}
        className={`bg-transparent border border-white/15 hover:border-nc-blue/50 font-mono text-[10px] tracking-[0.15em] uppercase text-zinc-300 hover:text-nc-blue pl-8 pr-2 py-2.5 cursor-pointer appearance-none focus:outline-none focus:ring-1 focus:ring-nc-blue transition-colors duration-300 ${compact ? "w-full" : ""}`}
      >
        {currencies.map((c) => (
          <option key={c.code} value={c.code} className="bg-[#0a0a0a] text-zinc-200">
            {c.code} {c.symbol}
          </option>
        ))}
      </select>
    </div>
  );
}
